import { Container, ExpandableSection, KeyValuePairs, SpaceBetween } from "@amzn/awsui-components-react";
import React, { useState, useEffect } from "react";

const AlteryxMeta = (props) =>{

	const [ alteryxData, setAlteryxData ] = useState([])

	useEffect(()=>{

		loadData()
	},[])

	const loadData= ()  =>{
		const allAlteryxData = props.data.map( (item) => {
			return formatAlteryxDataFromMeta(item)
		})
		setAlteryxData(allAlteryxData)
	}

	const formatAlteryxDataFromMeta = (alteryxItem) => {
		return (
			<Container>
                <KeyValuePairs
                    columns={3}
                    items={[
                        {
                            title: "Alteryx ID",
							label:"Alteryx ID",
                            value: alteryxItem?.alteryx_id ? alteryxItem.alteryx_id : "-",
                        }, 
                        {
                            title: "Sources",
                            label: "Sources",
							value: (
								<SpaceBetween size='xxs'>
									{alteryxItem?.source ? alteryxItem?.source.map( (table, index) => {
										return (
											<div key={table}>
												{table}
											</div>
										)
									}) : "-"	
									}
								</SpaceBetween>
							)
                        },
                        {
                            title: "Tables",
                            label: "Tables",
                            value: (
								<SpaceBetween size='xxs'>
									{alteryxItem?.tables ? alteryxItem.tables.map( (table, index) => {
										return (
											<div key={table}>
												{table}
											</div>
										)
									}) : "-"	
									}
								</SpaceBetween>
							)
                        },
                    ]}
                />
				<br/>
                <KeyValuePairs
                    columns={1}
					items={[
                        {
                            title: "Dependencies",
                            label: "Dependencies",
                            value: (
								<SpaceBetween size='xxs'>
									{alteryxItem?.dependencies ? alteryxItem.dependencies.map( (d, index) => {
										return (
											<div key={d}>
												{d}
											</div>
										)
									}) : "-"	
									}
								</SpaceBetween>
							)
                        },
						{
                            title: "Outputs",
                            label: "Outputs",
                            value: (
								<SpaceBetween size='xxs'>
									{alteryxItem?.outputs ? alteryxItem.outputs.map( (o, index) => {
										return (
											<div key={o}>
												{o}
											</div>
										)
									}) : "-"	
									}
								</SpaceBetween>
							)
						}
					]}
				/>
			</Container>
		)
	}

	return (
		<>
			<ExpandableSection headerText = "Alteryx">

				<SpaceBetween direction="vertical" size="m">
					{
						alteryxData.map( (alteryxItem, index) => {
							return (
								<div key={index}>
									{alteryxItem}
									<br/>
								</div>
							)
						})
					}
				</SpaceBetween>

			</ExpandableSection>
		</>
	)
}

export default AlteryxMeta;